// Global
export const RESET_STORE = 'RESET_STORE'

// USER
export const USER_LOGIN = 'USER_LOGIN'
export const USER_CREATE = 'USER_CREATE'
export const USER_RESET = 'USER_RESET'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_UPDATE = 'USER_UPDATE'

// ONBOARDING
export const UPDATE_ONBOARDING_FORM = 'UPDATE_ONBOARDING_FORM'
export const INITIALIZE_ONBOARDING = 'INITIALIZE_ONBOARDING'

// MODAL
export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'

// ACCOUNT DETAILS
export const GET_ACCOUNT_DETAILS = 'GET_ACCOUNT_DETAILS'
export const UPDATE_ACCOUNT_DETAILS_PAYMENT_INFO = 'UPDATE_ACCOUNT_DETAILS_PAYMENT_INFO'

// ACTIVE PROFILE
export const SET_ACTIVE_PROFILE = 'SET_ACTIVE_PROFILE'
export const UPDATE_ACTIVE_PROFILE = 'UPDATE_ACTIVE_PROFILE'

// LOCKER
export const SET_CURRENT_PARTICIPATION = 'SET_CURRENT_PARTICIPATION'
export const UPDATE_CURRENT_PARTICIPATION = 'UPDATE_CURRENT_PARTICIPATION'



// WEBPACK FOOTER //
// ./src/actions/types.js